<template>
    <div class="panel-body">

        <el-dialog title="成长系数" width="60%" :visible="growupDialogVisible" @close="close" center>
            <el-row class="column-name" justify="start">
                <span>成长系数标准</span>
            </el-row>
            <el-table :data="tableData1" stripe style="width: 100%">
                <el-table-column prop="col1" style="" label="机房运营时间">
                </el-table-column>
                <el-table-column prop="val1" label="成长系数">
                </el-table-column>
            </el-table>

            <el-row class="column-name" justify="start">
                <span>各数据中心IT负载设计容量</span>
            </el-row>
            <el-table :data="tableData2" stripe style="width: 100%">
                <el-table-column prop="name" style="" label="数据中心">
                </el-table-column>
                <el-table-column prop="startdate" label="运营时间">
                </el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import DomainalnApi from "@/api/domainaln/index";

    const deptNSHelper = createNamespacedHelpers("dept");

    export default {
        name: "groupup",

        data() {
            return {
                tableData1: [],

                tableData2: [],
            }
        },

        props: ['growupDialogVisible'],

        methods: {

            close() {
                this.$emit('update:growupDialogVisible', false);
            },

            getGroupupInfo() {
                this.tableData1 = [];
                DomainalnApi.list({domainid: "GROUPRATIOFOMULA"}).then(res => {
                    for (let i = 0; i < res.length; i++) {
                        res[i].value = res[i].value.replace(/\?/g, '').replace('&&', '-');
                        if (res[i].value.includes('-')) {
                            res[i].value = res[i].value.replace(/>/g, '').replace(/</g, '').replace(/=/g, '');
                            let tmpArr = res[i].value.split('-');
                            for (let j = 0; j < tmpArr.length; j++) {
                                tmpArr[j] = tmpArr[j] + '月';
                            }
                            res[i].value = tmpArr.join('-');
                        } else {
                            res[i].value = res[i].value + '月';
                        }
                        this.tableData1.push({
                            'col1': res[i].value,
                            'val1': res[i].description,
                        })
                    }
                });
            },

        },

        computed: {
            ...deptNSHelper.mapGetters(['deptSource$']),
        },

        mounted() {

            this.deptSource$.subscribe(v => {
                if (v != null && v.length > 0) {
                    this.tableData2 = v;
                    this.tableData2.sort((a, b) => {
                        return a.startdate > b.startdate ? -1 : a.startdate == b.startdate ? 0 : 1;
                    })
                }
            });

            this.getGroupupInfo();
        }
    }
</script>

<style scoped>

</style>